/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Card,
  Col,
  Row,
  Form,
  Select,
  InputNumber,
  Input,
  DatePicker,
  Table,
  Button,
} from "antd";
import Notes from "../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";

const HomeownerReceipt = () => {
  const [homeOwnerReciept, setHomeOwnerReciept] = useState("");

  const onChange = (value) => {
    console.log(`selected ${value}`);
    setHomeOwnerReciept(value);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  const columns = [
    {
      title: "GL Account",
      dataIndex: "gLAccount",
      key: "GL Account",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "Date",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "Description",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "Balance",
    },
    {
      title: "Amount To Pay",
      dataIndex: "amountToPay",
      key: "Amount To Pay",
    },
  ];
  const data = [
    {
      key: 1,
      gLAccount: "",
      date: "",
      description: "",
      balance: "Total:",
      amountToPay: "$0.00",
    },
  ];
  return (
    <div className="HomeownerReceipt">
      <div className="pageheading">
        <h1>New Homeowner Receipt</h1>
        <div className="pageHeadingBtns">
          <button>Repeat Receipt</button>
        </div>
      </div>
      <Form layout="vertical" name="basic" autoComplete="off">
        <Card>
          <Row gutter={16} justify="space-between">
            <Col span={7}>
              <Form.Item label="Homeowner" name="homeowner" required>
                <Select
                  showSearch
                  allowClear
                  placeholder="Type name or Lockbox ID to search"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value:
                        "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                      label:
                        "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                    },
                    {
                      value: "lucy",
                      label: "Lucy",
                    },
                    {
                      value: "tom",
                      label: "Tom",
                    },
                  ]}
                />
              </Form.Item>
              <Row>
                <Col span={8}>
                  <p>{homeOwnerReciept}</p>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Form.Item label="Amount" name="Amount" required>
                <InputNumber
                  addonBefore={<i className="fa-solid fa-dollar-sign"></i>}
                  defaultValue="0"
                  step="0.00"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item label="Remarks" name="Remarks">
                <Input placeholder="e.g. November Dues" />
              </Form.Item>
              <Form.Item label="Cash Account" name="CashAccount">
                <Select
                  placeholder="Automatic"
                  style={{
                    width: "100%  ",
                  }}
                  options={[
                    {
                      label: "Cash",
                      options: [
                        {
                          label: "23291: Rental Income Account",
                          value: "23291: Rental Income Account",
                        },
                        {
                          label: "23292: Security Deposits Bank Account",
                          value: "23292: Security Deposits Bank Account",
                        },
                      ],
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={7}>
              <Form.Item label="Receipt Date" name="ReceiptDate" required>
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item label="Reference" name="Reference">
                <Input placeholder="e.g. Check #123" />
              </Form.Item>
              <Form.Item label="Payment Type" name="PaymentType">
                <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  style={{
                    width: "100%  ",
                  }}
                  options={[
                    {
                      label: "Check",
                      value: "Check",
                    },
                    {
                      label: "Money Order",
                      value: "Money Order",
                    },
                    {
                      label: "Cash",
                      value: "Cash",
                    },
                    {
                      label: "Cashier's Check",
                      value: "Cashier's Check",
                    },
                    {
                      label: "Direct Deposit / ACH",
                      value: "Direct Deposit / ACH",
                    },
                    {
                      label: "Subsidized",
                      value: "Subsidized",
                    },
                    {
                      label: "Other",
                      value: "Other",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <br />
        <Card>
          <a href="" style={{ float: "right" }}>
            Clear Amounts
          </a>
          <Table columns={columns} dataSource={data} pagination={false} />
        </Card>
        <br />
        <Row gutter={16}>
          <Col>
            <Button type="primary">Save & Add Another</Button>
          </Col>
          <Col>
            <Button>Save</Button>
          </Col>
          <Col>
            <Button type="link" style={{paddingLeft:0}}>Cancel</Button>
          </Col>
        </Row>
        <br />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            {/* <Notes /> */}
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </Form>

      <div className="RightSidebar">
      </div>
    </div>
  );
};

export default HomeownerReceipt;
